import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="bg-[#12100E] text-stone-400 border-t border-white/[0.06]" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div className="space-y-4">
        <Logo dark />
        <p className="text-sm leading-relaxed max-w-xs">
          La plateforme de rencontres conçue pour la Côte d'Ivoire. Trouvez l'amour, l'amitié ou l'exclusivité.
        </p>
      </div>
      <div>
        <h4 className="font-heading text-stone-100 font-semibold mb-4 text-sm tracking-wider uppercase">Catégories</h4>
        <ul className="space-y-2 text-sm">
          <li><Link to="/categorie/lago" data-testid="footer-link-lago" className="hover:text-[#E05638] transition-colors">FodindinLago</Link></li>
          <li><Link to="/categorie/love" data-testid="footer-link-love" className="hover:text-[#4ade80] transition-colors">FodindinLove</Link></li>
          <li><Link to="/categorie/vip" data-testid="footer-link-vip" className="hover:text-[#D4AF37] transition-colors">FodindinClubVIP</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-heading text-stone-100 font-semibold mb-4 text-sm tracking-wider uppercase">Bientôt</h4>
        <ul className="space-y-2 text-sm">
          <li>Messagerie instantanée</li>
          <li>Photos de profil</li>
          <li>Salons vidéo</li>
        </ul>
      </div>
    </div>
    {/* Maillage interne : les pages locales captent les recherches « rencontre + ville » */}
    <div className="mx-auto max-w-7xl px-4 pb-8 sm:px-6 lg:px-8" data-testid="footer-villes">
      <p className="mb-3 text-[11px] font-bold uppercase tracking-[0.2em] text-white/40">
        Annonces par ville
      </p>
      <div className="flex flex-wrap gap-2">
        {[
          ["abidjan", "Abidjan"], ["cocody", "Cocody"], ["yopougon", "Yopougon"],
          ["marcory", "Marcory"], ["treichville", "Treichville"], ["plateau", "Plateau"],
          ["abobo", "Abobo"], ["adjame", "Adjamé"], ["bouake", "Bouaké"],
          ["yamoussoukro", "Yamoussoukro"], ["san-pedro", "San-Pédro"], ["paris", "Paris"],
        ].map(([slug, nom]) => (
          <Link key={slug} to={`/ville/${slug}`} data-testid={`footer-ville-${slug}`}
            className="rounded-full border border-white/15 px-3 py-1.5 text-xs text-white/70 transition-colors hover:border-[#E05638] hover:text-white">
            Rencontres à {nom}
          </Link>
        ))}
      </div>
    </div>
    <div className="border-t border-white/[0.06] py-6 text-center text-xs tracking-wide">
      © 2026 FodindinCa — Le cœur de la Côte d'Ivoire bat ici 🇨🇮
    </div>
  </footer>
);
